module.exports = "body {\n    background: #f6f6f6;\n}"